import { UserType } from '../interfaces/userType.enum';

/**
 * The roles PosTerminalController and PosStoreAssignmentController admit on their read
 * endpoints (terminal list, store-assignment list, assignable users):
 * @PreAuthorize("hasAnyRole('InstitutionAdmin', 'StoreAdmin', 'StoreManager')"). An Accountant can
 * read POS sales but not these, so screens must not call them (and must not toast the 403) for
 * that role.
 */
export const POS_STORE_STAFF_ROLES: UserType[] = [UserType.InstitutionAdmin, UserType.StoreAdmin, UserType.StoreManager];
